/**
 * PASSIVE EVENTS FIX - LICENSE GLOBAL
 * Risolve i warning di eventi non-passive nel bundle-head.js
 */

document.addEventListener('DOMContentLoaded', function() {
  // Applica il fix solo se non è già stato applicato
  if (window.passiveEventsFixApplied) return;
  
  // Cache della funzione originale
  const originalAddEventListener = EventTarget.prototype.addEventListener;
  
  // Eventi che dovrebbero essere passivi per migliorare le performance
  const passiveEvents = ['wheel', 'mousewheel', 'touchstart', 'touchmove'];
  
  // Funzione per rendere passivi gli eventi di scroll
  function makeEventListenersPassive() {
    EventTarget.prototype.addEventListener = function(type, listener, options) {
      let modifiedOptions = options;
      
      // Se l'evento è nella lista degli eventi passivi e le opzioni non specificano già passive
      if (passiveEvents.includes(type) &&
          typeof options === 'object' &&
          options !== null &&
          !('passive' in options)) {
        // Creiamo un nuovo oggetto opzioni con passive: true
        modifiedOptions = Object.assign({}, options, { passive: true });
      } else if (passiveEvents.includes(type) &&
                 typeof options === 'undefined') {
        // Se non ci sono opzioni, le impostiamo come passive: true
        modifiedOptions = { passive: true };
      }
      
      // Chiamiamo la funzione originale con le opzioni modificate
      return originalAddEventListener.call(this, type, listener, modifiedOptions);
    };
  }
  
  // Applichiamo il fix
  makeEventListenersPassive();
  window.passiveEventsFixApplied = true;
});